// One disruptive element per page: a stamp-style pull-quote that breaks the grid.
export default function StampQuote({ text, kicker = "FROM THE MANIFESTO" }) {
  return (
    <div className="px-6 sm:px-12 lg:px-20 py-14 sm:py-20" data-testid="stamp-quote">
      <div className="relative border-4 border-black bg-primary px-8 py-10 sm:px-14 sm:py-12 shadow-hard">
        <span className="absolute -top-4 left-8 border-2 border-black bg-background px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.25em]">
          {kicker}
        </span>
        <p className="font-display uppercase text-3xl sm:text-5xl leading-[0.95] tracking-tight text-white">
          {text}
        </p>
      </div>
    </div>
  );
}
